"use strict";
// https://datatracker.ietf.org/doc/html/draft-kelly-json-hal
Object.defineProperty(exports, "__esModule", { value: true });
exports.halCollection = exports.halItem = exports.halLink = void 0;
const halLink = (item, basePath) => ({
    href: `${basePath}/${item.name}`,
    name: item.name,
});
exports.halLink = halLink;
const halItem = (item, basePath) => {
    return {
        ...item,
        _links: {
            collection: { href: basePath },
            self: (0, exports.halLink)(item, basePath),
        },
    };
};
exports.halItem = halItem;
const halCollection = (items, basePath) => {
    return {
        size: items.length,
        total: items.length,
        _links: {
            item: items.map((item) => (0, exports.halLink)(item, basePath)),
            self: { href: basePath },
        },
        _embedded: { item: items.map((item) => (0, exports.halItem)(item, basePath)) },
    };
};
exports.halCollection = halCollection;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGFsLm1vZGVsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21vZGVscy9oYWwubW9kZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDZEQUE2RDs7O0FBNEJ0RCxNQUFNLE9BQU8sR0FBRyxDQUE2QixJQUFPLEVBQUUsUUFBZ0IsRUFBVyxFQUFFLENBQUMsQ0FBQztJQUMxRixJQUFJLEVBQUUsR0FBRyxRQUFRLElBQUksSUFBSSxDQUFDLElBQUksRUFBRTtJQUNoQyxJQUFJLEVBQUUsSUFBSSxDQUFDLElBQUk7Q0FDaEIsQ0FBQyxDQUFBO0FBSFcsUUFBQSxPQUFPLFdBR2xCO0FBRUssTUFBTSxPQUFPLEdBQUcsQ0FBNkIsSUFBTyxFQUFFLFFBQWdCLEVBQWMsRUFBRTtJQUMzRixPQUFPO1FBQ0wsR0FBRyxJQUFJO1FBQ1AsTUFBTSxFQUFFO1lBQ04sVUFBVSxFQUFFLEVBQUUsSUFBSSxFQUFFLFFBQVEsRUFBRTtZQUM5QixJQUFJLEVBQUUsSUFBQSxlQUFPLEVBQUMsSUFBSSxFQUFFLFFBQVEsQ0FBQztTQUM5QjtLQUNGLENBQUE7QUFDSCxDQUFDLENBQUE7QUFSWSxRQUFBLE9BQU8sV0FRbkI7QUFFTSxNQUFNLGFBQWEsR0FBRyxDQUE2QixLQUFVLEVBQUUsUUFBZ0IsRUFBb0IsRUFBRTtJQUMxRyxPQUFPO1FBQ0wsSUFBSSxFQUFFLEtBQUssQ0FBQyxNQUFNO1FBQ2xCLEtBQUssRUFBRSxLQUFLLENBQUMsTUFBTTtRQUNuQixNQUFNLEVBQUU7WUFDTixJQUFJLEVBQUUsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLElBQUksRUFBRSxFQUFFLENBQUMsSUFBQSxlQUFPLEVBQUMsSUFBSSxFQUFFLFFBQVEsQ0FBQyxDQUFDO1lBQ2xELElBQUksRUFBRSxFQUFFLElBQUksRUFBRSxRQUFRLEVBQUU7U0FDekI7UUFDRCxTQUFTLEVBQUUsRUFBRSxJQUFJLEVBQUUsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLElBQUksRUFBRSxFQUFFLENBQUMsSUFBQSxlQUFPLEVBQUMsSUFBSSxFQUFFLFFBQVEsQ0FBQyxDQUFDLEVBQUU7S0FDbEUsQ0FBQTtBQUNILENBQUMsQ0FBQTtBQVZZLFFBQUEsYUFBYSxpQkFVekIifQ==